import moment from 'moment-timezone';

// The Care time fields hold a naive wall-clock string 'YYYY-MM-DDTHH:mm' read in a fixed zone (IST
// by default). react-datepicker works on browser-local Dates, so the picker is fed a Date whose
// LOCAL fields equal that wall clock: the round trip never touches the browser's offset, so the
// value means the same IST time whatever zone the Ops laptop is set to.
const VALUE_RE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

// Field value -> picker Date (null when empty or malformed).
export function value_to_picker_date(value) {
  const m = VALUE_RE.exec(value || '');
  if (!m) return null;
  const [y, mo, d, h, mi] = m.slice(1).map(Number);
  const date = new Date(y, mo - 1, d, h, mi, 0, 0);
  // rejects 31 Feb etc.; a browser-local DST gap (not IST) would also land here
  if (
    date.getFullYear() !== y ||
    date.getMonth() !== mo - 1 ||
    date.getDate() !== d ||
    date.getHours() !== h ||
    date.getMinutes() !== mi
  ) {
    return null;
  }
  return date;
}

const pad = (n) => String(n).padStart(2, '0');

// Picker Date -> field value ('' for no date). Seconds are dropped: minute precision.
export function picker_date_to_value(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

// "Now" in the field's zone, as a picker Date: the picker's max (no future times).
export const picker_max_date = (now_ms, iana_timezone) =>
  value_to_picker_date(moment(now_ms).tz(iana_timezone).format('YYYY-MM-DDTHH:mm'));

// Time-list filter: a slot is offered only if it is not after max.
export const is_time_allowed = (date, max_date) =>
  !max_date || !date || date.getTime() <= max_date.getTime();
